import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Boxes, LockKeyhole, Mail } from "lucide-react";
import { api, setToken } from "../lib/api";
import { useI18n } from "../lib/i18n";

export function LoginPage() {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await api.post<{ token: string; user: { id: string; email: string; name: string; role: string } }>("/api/auth/login", {
        email,
        password
      });
      setToken(response.token);
      localStorage.setItem("erp_user", JSON.stringify(response.user));
      navigate("/");
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : "登录失败");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <section className="login-panel">
        <div className="login-brand">
          <div className="brand-mark large">
            <Boxes size={26} />
          </div>
          <div>
            <strong>{t("跨境电商 ERP")}</strong>
            <span>Amazon · TikTok Shop · SHEIN</span>
          </div>
        </div>
        <div className="login-heading">
          <h1>{t("登录运营工作台")}</h1>
          <p>{t("管理全渠道订单、商品、库存和平台同步任务。")}</p>
        </div>
        <form className="form-stack" onSubmit={submit}>
          <label className="field">
            <span>{t("邮箱")}</span>
            <div className="input-with-icon">
              <Mail size={17} />
              <input value={email} onChange={(event) => setEmail(event.target.value)} type="email" autoComplete="username" placeholder="admin@example.com" />
            </div>
          </label>
          <label className="field">
            <span>{t("密码")}</span>
            <div className="input-with-icon">
              <LockKeyhole size={17} />
              <input value={password} onChange={(event) => setPassword(event.target.value)} type="password" autoComplete="current-password" />
            </div>
          </label>
          {error ? <div className="form-error">{error}</div> : null}
          <button type="submit" className="primary-button full-width" disabled={loading}>
            {loading ? t("登录中...") : t("进入工作台")}
          </button>
        </form>
        <div className="login-note">{t("管理员账号由服务器环境变量配置。")}</div>
      </section>
    </div>
  );
}
